import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlSegment } from '@angular/router';
import { Store } from '@ngxs/store';

import { RoutingService } from '@shared/services/routing.service';

import { AppState } from '../../app.state';
import { map } from 'rxjs/operators';

export const authGuard: CanMatchFn = (_route, segments: UrlSegment[]) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(AppState.isAuthenticated)
              .pipe(
                  map((auth) => {
                    if (auth) return true;
                    const returnUrl = '/' + segments.map((s) => s.path).join('/');
                    return router.createUrlTree(
                        [RoutingService.LOGIN],
                        { queryParams: { returnUrl } },
                    );
                  }),
              );
};
